import { TFuelLevyType, RateCardTableType } from '@types';

const labelMap: Record<string, Record<TFuelLevyType, string>> = {
	admin: {
		global_shipper: 'Shipper Global',
		global_carrier: 'Carrier Global',
		customer: 'Company',
		rate_card: 'Lane',
	},
	shipper: {
		global_shipper: 'Shipper Global',
		global_carrier: 'Carrier Global',
		customer: 'Shipper',
		rate_card: 'Lane',
	},
	carrier: {
		global_shipper: 'Shipper Global',
		global_carrier: 'Carrier Global',
		customer: 'Carrier',
		rate_card: 'Lane',
	},
};

export const getFuelLevyTypeLabel = (type: TFuelLevyType, customerType: RateCardTableType): string => {
	const context = customerType === 'linked' ? 'admin' : customerType;
	return labelMap[context]?.[type] ?? type;
};
